import React from 'react';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as Sentry from '@sentry/react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ModalEnum } from 'myParkdUtils/enums';
import { CONTENT_REPORT_A_BUG_TO_SUPPORT_MODAL } from 'myParkdUtils/basicMessageModalContent';

class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventId: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true });
        Sentry.withScope((scope) => {
            scope.setExtras(errorInfo);
            const eventId = Sentry.captureException(error);
            this.setState({ eventId });
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={'error-boundary' + (this.props.className ? ' ' + this.props.className : '')}>
                    <FormattedMessage
                        id="ERROR_BOUNDARY_SOMETHING_WENT_WRONG"
                        values={{
                            a: (...chunks) => (
                                <a
                                    href="!#"
                                    onClick={() =>
                                        this.props.openModal(ModalEnum.SEND_MESSAGE_TO_SUPPORT, {
                                            modalContent: CONTENT_REPORT_A_BUG_TO_SUPPORT_MODAL,
                                        })
                                    }
                                >
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                </div>
            );
        }
        return this.props.children;
    }
}

function mapStateToProps(state, props) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            openModal: modalWindowActions.updateModalWindow,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalErrorBoundary);
